'use strict';

angular.module('linagora.esn.profile')

  .component('profileSidebar', {
    template: require('./sidebar.pug')
  });
